export default __webpack_public_path__ + "static/media/ChevronRightFilled.d2b33e72.svg";